import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { path } from 'ramda';

import {
  Container,
  BackgroundWrapper,
  Logo,
  Links,
  AppStoreIcon,
  Copyright,
  Disclaimer,
  AppStoreLink,
  SubFooter,
} from './footer.styles';
import { ICON_WINNOW_LOGO } from '../icon';
import { HiddenOnPlatform } from '../hiddenOnPlatform';
import { Divider } from '../divider';
import { FooterLinksSection } from './footerLinksSection';
import { footerLinksPropType, assetPropType } from '../../../propTypes';
import { renderWhenTrue } from '../../utils/rendering';

export class Footer extends PureComponent {
  static propTypes = {
    isVisible: PropTypes.bool,
    links: footerLinksPropType,
    storeUrl: PropTypes.string,
    storeIcon: assetPropType,
    infoDisclaimer: PropTypes.string,
    copyrightInfo: PropTypes.string,
  };

  get storeIconSrc() {
    return path(['file', 'url'], this.props.storeIcon);
  }

  renderFooter = () => (
    <BackgroundWrapper>
      <Container>
        <Logo name={ICON_WINNOW_LOGO} />
        <Links>
          {this.props.links.map(({ links, title }) => (
            <FooterLinksSection key={title} title={title} links={links} />
          ))}
        </Links>
        <HiddenOnPlatform tablet desktop desktopFull desktopWide>
          <Divider />
        </HiddenOnPlatform>

        <SubFooter>
          <AppStoreLink to={this.props.storeUrl}>
            <AppStoreIcon src={this.storeIconSrc} />
          </AppStoreLink>

          <Disclaimer>{this.props.infoDisclaimer}</Disclaimer>
          <Copyright>{this.props.copyrightInfo}</Copyright>
        </SubFooter>
      </Container>
    </BackgroundWrapper>
  );

  render = () => renderWhenTrue(this.renderFooter)(this.props.isVisible);
}
